<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" style="width: 750px" @click.stop>
                <div class="dialog-title" v-t="'message.action_edit_chat_bot'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="200px">
                        <div class="dialog-form-item">
                            <el-form-item prep="displayName" ref="displayName">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_display_name'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item label="endpoint" ref="endpoint">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_url'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="endpoint" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.endpoint.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item label="apiKey" ref="apiKey">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_api_key'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="apiKey" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.apiKey.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item label="pluginId" ref="pluginId">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_plugin_id'"></span></div>
                                <el-input id="pluginId" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.pluginId.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item label="modelKey" ref="modelKey">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_target_llm_model'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="modelKey" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.modelKey.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item label="systemPrompt" ref="systemPrompt">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_system_prompt'"></span></div>
                                <el-input id="systemPrompt" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.systemPrompt.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item label="ignoreWords" ref="ignoreWords">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_ignore_words'"></span></div>
                                <el-input id="ignoreWords" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.ignoreWords.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="addKey()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonValidate from '../../../common-validate.js';

export default {
    props: ['keyVault'],

    data() {
        return {
            inputForm: {
                displayName: {validationRule: "reqDisplayName", valid: true, value: null, isComposing: false},
                endpoint: {validationRule: "reqUrl", valid: true, value: null, isComposing: false},
                apiKey: {validationRule: "reqToken", valid: true, value: null, isComposing: false},
                pluginId: {validationRule: "text100", valid: true, value: null, isComposing: false},
                modelKey: {validationRule: "reqText200", valid: true, value: null, isComposing: false},
                systemPrompt: {validationRule: "text100", valid: true, value: null, isComposing: false},
                ignoreWords: {validationRule: "text100", valid: true, value: null, isComposing: false},
            },
            disableButton: true,
            existTargetType: [],
        };
    },

    created: function () {
        this.inputForm.displayName.value = this.keyVault.displayName;
        this.inputForm.endpoint.value = this.keyVault.endpoint;
        this.inputForm.apiKey.value = this.keyVault.apiKey;
        this.inputForm.pluginId.value = this.keyVault.pluginId;
        this.inputForm.modelKey.value = this.keyVault.modelKey;
        this.inputForm.systemPrompt.value = this.keyVault.systemPrompt;
        this.inputForm.ignoreWords.value = this.keyVault.ignoreWords;
        this.disableButton = true;
    },

    methods: {
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.$refs[eventTargetId].clearValidate();
                this.inputForm[eventTargetId].valid = true;
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
                this.inputForm[eventTargetId].valid = false;
            }
            this.setButtonStatus();
        },

        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },

        setButtonStatus() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },

        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },

        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },

        addKey() {
            this.$emit('save', {
                displayName: this.inputForm.displayName.value,
                endpoint: this.inputForm.endpoint.value,
                apiKey: this.inputForm.apiKey.value,
                pluginId: this.inputForm.pluginId.value,
                modelKey: this.inputForm.modelKey.value,
                systemPrompt: this.inputForm.systemPrompt.value,
                ignoreWords: this.inputForm.ignoreWords.value,
            })
        },
    }
}
</script>
<style scoped>
</style>

